import { createApp } from "vue"
import App from "./App.vue"
import "./assets/main.css"
import "@fortawesome/fontawesome-free/css/fontawesome.css"
import "@fortawesome/fontawesome-free/css/solid.css"

const app = createApp(App)
app.mount("#app")
